import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Home, Lock } from 'lucide-react';
import useShiftsStore from '../store/useShiftsStore';
import useAuthStore from '../store/useAuthStore';

export default function ShiftGuard() {
  const { activeShifts, fetchActiveShifts } = useShiftsStore();
  const { isShiftRequired } = useAuthStore();
  const navigate = useNavigate();
  // Локальный флаг — спиннер только при первом входе, не зависит от глобального store.loading
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    fetchActiveShifts().finally(() => setInitialized(true));
  }, []);

  // Admins and guests with disabled shift requirement bypass the guard.
  if (!isShiftRequired()) return <Outlet />;

  if (!initialized) {
    return (
      <div className="loading">
        <div className="spinner" />
      </div>
    );
  }

  if (activeShifts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-[#f8f9fc] px-6 text-center">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-5">
          <Lock className="w-7 h-7 text-slate-400" strokeWidth={1.5} />
        </div>
        <h2 className="text-[18px] font-bold text-slate-800 mb-2">Смена не открыта</h2>
        <p className="text-[14px] text-slate-500 leading-relaxed mb-7 max-w-[260px]">
          Чтобы работать с этим разделом, сначала откройте смену на главной странице.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white text-[14px] font-semibold px-6 py-3 rounded-[14px] transition-colors"
        >
          <Home size={16} strokeWidth={2.5} />
          На главную
        </button>
      </div>
    );
  }

  return <Outlet />;
}
